import FormComponent from '../FormComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const CLICK_EVENT = 'click';

class SessionPlayersListItem extends FormComponent {
	constructor(containerElement, config) {
		super(containerElement, config);
		this.sessionPlayerdata = {};
		this._changePlayersCallbacks = [];
	}

	markup(value, data = {}, titleMarkup) {
		this.sessionPlayerItemClass = `lta-session-player-conainer-${data.id}`;
		this.inputID = `lta-session-players-list-container-id-${data.id}`;
		const selectedPlayers = this.getSelectedPlayers();
		const fullyBookedWarning =
			data?.availableSeats > 0 &&
			data?.availableSeats - selectedPlayers?.length <= 0 &&
			data?.players.length !== selectedPlayers?.length;
		return `<div class="${this.sessionPlayerItemClass}">
					<div class="lta-session-players--details ${data?.hasError ? 'is-invalid' : ''}">
						<div class="lta-session-players--details-title u-h1 u-mb-1">${data?.sessionName}</div>
						<div class="lta-session-players--details-seats u-label2 u-mb-2"> 
							<div>${data?.availableSeats} left &#x2022; Free &#x2022; ${data?.ageLimitMessage}</div>
						</div>
						<div class="u-label2 u-mb-3 u-text-grey-ui-mid">${data?.instructionText}</div>
						${fullyBookedWarning ? this.renderFullBookedSnack() : ''}
						${this.renderSessionPlayerList(data)}
					</div>
				</div>`;
	}

	renderFullBookedSnack() {
		const message = `Session is now fully booked. No more players can be added.`;
		return `
			<div class="lta-snackbar lta-snackbar--warning has-icon u-mb-2 u-w-100">
				<p class="lta-snackbar__label title title" aria-label="${message}">
					${message}
				</p>
				<div class="lta-snackbar__icon">
				<svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" style="color:currentColor;" fill="currentColor" alt="info" aria-hidden="true"><use xlink:href="/static/images/icons/lta-icons.svg#info"></use></svg>
				</div> 
			</div>`;
	}

	renderSessionPlayerList(sessionData) {
		const selectedPlayersCount = this.getSelectedPlayers()?.length;
		const itemList = sessionData?.players
			?.map((data, index) => {
				const isDisable = this.data?.availableSeats - selectedPlayersCount <= 0 && !data.isChecked;
				return this.renderSessionPlayerListItem(data, isDisable);
			})
			.join('');

		const isPlayersExist = !!sessionData?.players?.length > 0;
		const isSeatsAvailable = sessionData?.players?.length <= sessionData?.availableSeats;
		const isSelectAllSelected = !sessionData?.players?.some((item) => !!item?.isChecked === false);
		return `
		<div class="lta-session-players--details-list u-my-2 md:u-mr-3 g-col-12 u-h-100 u-w-100">
			${
				isPlayersExist
					? `<div class="lta-form-check--error u-my-3">Please select at least one player</div>
				${
					isSeatsAvailable
						? `<div id="flexRadioForm" class="lta-form-check lta-form-checkbox">
								<input class="lta-form-check-input" type="checkbox" name="flexCheckDefault" id="js-select-all-player" value="" ${
									isSelectAllSelected ? `checked` : ``
								}>
								<label class="lta-form-check-label" for="flexCheckDefault1">Select all players</label>
							</div>
							<div class="separator u-mt-2 u-mb-3"></div>`
						: ``
				}`
					: ''
			}
			<div class="lta-session-players--details-list-data u-ml-3 u-mb-4">
				${itemList}
			</div>
		</div>`;
	}

	renderSessionPlayerListItem(player, isDisable) {
		return `<div class="lta-session-players--details-list-item u-flex u-align-center u-my-2 ${
			isDisable ? 'is-disable' : ''
		}">
					<input class="lta-form-check-input u-mr-2" type="checkbox" name="sessionPlayer" id=${player?.id} ${
			isDisable ? 'disabled' : ''
		} ${player?.isChecked ? `checked` : ``}>
					<div class="lta-session-players--details-list-card u-px-3 u-py-2 u-rounded u-h-100 u-w-100 ${
						player?.isChecked ? `isSelected` : ``
					}">
						<div class="u-caption1 u-text-grey-lta u-mb-0.5">${player?.name}</div>
						<div class="u-flex u-align-center">
							<div class="u-body1 u-text-grey-lta md:u-mr-1">${player?.gender},</div>
							<div class="u-body1 u-text-grey-lta">${player?.ageText}</div>
						</div>
					</div>
				</div>`;
	}

	afterRender() {
		this.sessionContainerElement = SelectorEngine.findOne(`.${this.sessionPlayerItemClass}`, this.containerEl);
		this.initEventListeners();
	}

	initEventListeners() {
		this.selectAllElement = SelectorEngine.findOne('#js-select-all-player', this.sessionContainerElement);
		if (this.selectAllElement) {
			EventHandler.on(this.selectAllElement, CLICK_EVENT, () => {
				this.handleSelectAll(this.selectAllElement?.checked);
			});
		}

		const playersCards = SelectorEngine.find('.lta-session-players--details-list-item', this.sessionContainerElement);
		if (playersCards) {
			for (const playersCard of playersCards) {
				const checkboxElement = SelectorEngine.findOne('input[type="checkbox"]', playersCard);
				EventHandler.on(checkboxElement, CLICK_EVENT, (event) => {
					this.handleCheckboxClickHandler(event);
				});

				EventHandler.on(playersCard, CLICK_EVENT, () => {
					this.cardClickHandler(checkboxElement);
				});
			}
		}
	}

	afterPlayersChange(currentSession) {
		for (const callback of this._changePlayersCallbacks) {
			callback(currentSession);
		}
	}

	onPlayerChange(callback) {
		this._changePlayersCallbacks.push(callback);
	}

	cardClickHandler(checkboxElement) {
		const updatePlayerDetails = this.data?.players?.find((player) => player?.id === checkboxElement?.id);
		if (!checkboxElement?.disabled) {
			updatePlayerDetails.isChecked = !checkboxElement?.checked;
			this.data = {
				...this.data,
				hasError: false,
				players: [...this.data?.players]
			};
			this.afterPlayersChange(this.data);
		}
	}

	handleSelectAll(isChecked) {
		this.data?.players?.forEach((player) => {
			player['isChecked'] = isChecked;
		});

		this.data = {
			...this.data,
			hasError: false,
			players: [...this.data?.players]
		};
		this.afterPlayersChange(this.data);
	}

	handleCheckboxClickHandler(event) {
		event.stopPropagation();
		const updatePlayerDetails = this.data?.players?.find((player) => player?.id === event?.currentTarget?.id);
		updatePlayerDetails.isChecked = event?.currentTarget?.checked;

		this.data = {
			...this.data,
			hasError: false,
			players: [...this.data?.players]
		};
		this.afterPlayersChange(this.data);
	}

	validate() {
		return this.data?.players?.some((player) => player?.isChecked) || this.data.availableSeats === 0;
	}

	getSelectedPlayers() {
		return this.data?.players?.filter((player) => !!player?.isChecked) || [];
	}
}

export default SessionPlayersListItem;
